module.exports = __webpack_public_path__ + "img/symbol_6.3278e007.png";